import React from 'react';
import { Alert, AlertIcon, AlertDescription } from '@chakra-ui/react';

const CASBypassWarning: React.FC = () => {
  return (
    <Alert status="info" colorScheme="cyan">
      <AlertIcon />

      <AlertDescription data-selector="casBypass-warning-text">
        Note: The student's CAS has been processed outside of CAS Shield. The student is not required to complete this
        section.
      </AlertDescription>
    </Alert>
  );
};

export default CASBypassWarning;
